import { DependencyOperator, ExternalData, FbeFormFeature, FbeMode, FbeNumberMultiAdjustmentDirectionType, FbeNumberMultiAdjustmentImpactType, FbeOption, FbeQuestionAnswerAction, FbeQuestionFeature, FbeQuestionLoopRepeatType, FbeQuestionType, FbeRepeatType, FbeResultSystemDestination, FbeSection, FbeSectionDisplayType, FbeSectionFeature, FbeType, FbeWorkflowStates, getAnswerActionDisplayName, getFormFeatureDisplayName, getFormTypeDisplayName, getLogicalOperatorDisplayName, getMappingTypeDisplayName, getMappingTypeOperatorDisplayName, getModeDisplayName, getMultiAdjustmentDirectionDisplayName, getMultiAdjustmentImpactDisplayName, getOperatorDisplayName, getQuestionFeatureDisplayName, getQuestionLoopRepeatDisplayName, getQuestionTypeDisplayName, getRepeatTypeDisplayName, getResultSystemDestinationDisplayName, getRoleDisplayName, getSectionDisplayTypeName, getSectionFeatureDisplayName, getTableTypeDisplayName, getWorkflowDisplayName, LogicalOperator, MappingOperator, MappingType, TableType, TacoRole } from './fbeTypes';

export const modeOptions = [
  {
    value: FbeMode.LIVE,
    label: getModeDisplayName( FbeMode.LIVE ),
    disabled: false,
    key: 'mode',
  },
  {
    value: FbeMode.TEST_QDPLUS,
    label: getModeDisplayName( FbeMode.TEST_QDPLUS ),
    disabled: false,
    key: 'mode',
  },
  {
    value: FbeMode.TEST_NEBSEB,
    label: getModeDisplayName( FbeMode.TEST_NEBSEB ),
    disabled: false,
    key: 'mode',
  }
];

export const tableTypeOptions = [
  {
    value: TableType.NUMBER,
    label: getTableTypeDisplayName( TableType.NUMBER ),
    disabled: false,
    key: 'tableType',
  },
  {
    value: TableType.PLUMBING,
    label: getTableTypeDisplayName( TableType.PLUMBING ),
    disabled: false,
    key: 'tableType',
  }
];


export const operatorOptions = [
  {
    value: DependencyOperator.EQUALS,
    label: getOperatorDisplayName( DependencyOperator.EQUALS ),
    disabled: false,
    key: 'operator',
  },
  {
    value: DependencyOperator.NOT_EQUALS,
    label: getOperatorDisplayName( DependencyOperator.NOT_EQUALS ),
    disabled: false,
    key: 'operator',
  },
  {
    value: DependencyOperator.INCLUDES,
    label: getOperatorDisplayName( DependencyOperator.INCLUDES ),
    disabled: false,
    key: 'operator',
  },
  {
    value: DependencyOperator.NOT_INCLUDES,
    label: getOperatorDisplayName( DependencyOperator.NOT_INCLUDES ),
    disabled: false,
    key: 'operator',
  },
  {
    value: DependencyOperator.SMALLER,
    label: getOperatorDisplayName( DependencyOperator.SMALLER ),
    disabled: false,
    key: 'operator',
  },
  {
    value: DependencyOperator.GREATER,
    label: getOperatorDisplayName( DependencyOperator.GREATER ),
    disabled: false,
    key: 'operator',
  },
];

export const logicalOperatorOptions = [
  {
    value: LogicalOperator.AND,
    label: getLogicalOperatorDisplayName( LogicalOperator.AND ),
    disabled: false,
    key: 'logicalOperator',
  },
  {
    value: LogicalOperator.OR,
    label: getLogicalOperatorDisplayName( LogicalOperator.OR ),
    disabled: false,
    key: 'logicalOperator',
  },
];

export const resultSystemDestinationOptions = [
  {
    value: FbeResultSystemDestination.NONE,
    label: getResultSystemDestinationDisplayName( FbeResultSystemDestination.NONE ),
    disabled: false,
    key: 'resultSystemDestination',
  },
  {
    value: FbeResultSystemDestination.DATABASE,
    label: getResultSystemDestinationDisplayName( FbeResultSystemDestination.DATABASE ),
    disabled: false,
    key: 'resultSystemDestination',
  },
  {
    value: FbeResultSystemDestination.SHAREPOINT_LIST,
    label: getResultSystemDestinationDisplayName( FbeResultSystemDestination.SHAREPOINT_LIST ),
    disabled: false,
    key: 'resultSystemDestination',
  },
  {
    value: FbeResultSystemDestination.TRACE_PDM,
    label: getResultSystemDestinationDisplayName( FbeResultSystemDestination.TRACE_PDM ),
    disabled: false,
    key: 'resultSystemDestination',
  },
];

export const multiAdjustmentImpactOptions = [
  {
    value: FbeNumberMultiAdjustmentImpactType.MINUS,
    label: getMultiAdjustmentImpactDisplayName( FbeNumberMultiAdjustmentImpactType.MINUS ),
    disabled: false,
    key: 'multiAdjustmentDirection',
  },
  {
    value: FbeNumberMultiAdjustmentImpactType.PLUS,
    label: getMultiAdjustmentImpactDisplayName( FbeNumberMultiAdjustmentImpactType.PLUS ),
    disabled: false,
    key: 'multiAdjustmentDirection',
  },
]

export const multiAdjustmentDirectionOptions = [
  {
    value: FbeNumberMultiAdjustmentDirectionType.X,
    label: getMultiAdjustmentDirectionDisplayName( FbeNumberMultiAdjustmentDirectionType.X ),
    disabled: false,
    key: 'multiAdjustmentDirection',
  },
  {
    value: FbeNumberMultiAdjustmentDirectionType.Y,
    label: getMultiAdjustmentDirectionDisplayName( FbeNumberMultiAdjustmentDirectionType.Y ),
    disabled: false,
    key: 'multiAdjustmentDirection',
  },
]

export const answerActionOptions = [
  {
    value: FbeQuestionAnswerAction.CREATE_DEVIATION,
    label: getAnswerActionDisplayName( FbeQuestionAnswerAction.CREATE_DEVIATION ),
    disabled: false,
    key: 'answerAction',
},
]

export const questionLoopRepeatOptions = [
  {
      value: FbeQuestionLoopRepeatType.AFTER,
      label: getQuestionLoopRepeatDisplayName( FbeQuestionLoopRepeatType.AFTER ),
      disabled: false,
      key: 'questionLoopRepeat',
  },
  {
    value: FbeQuestionLoopRepeatType.BEFORE,
    label: getQuestionLoopRepeatDisplayName( FbeQuestionLoopRepeatType.BEFORE ),
    disabled: false,
    key: 'questionLoopRepeat',
},
{
  value: FbeQuestionLoopRepeatType.REPEAT,
  label: getQuestionLoopRepeatDisplayName( FbeQuestionLoopRepeatType.REPEAT ),
  disabled: false,
  key: 'questionLoopRepeat',
},
]

export const questionFeatureOptions = [
  {
    value: FbeQuestionFeature.CREATE_DEVIATION,
    label: getQuestionFeatureDisplayName( FbeQuestionFeature.CREATE_DEVIATION ),
    disabled: false,
    key: 'questionFeature',
},
{
  value: FbeQuestionFeature.EXTEND_STATIC_QUESTION,
  label: getQuestionFeatureDisplayName( FbeQuestionFeature.EXTEND_STATIC_QUESTION ),
  disabled: false,
  key: 'questionFeature',
},
{
      value: FbeQuestionFeature.MANIPULATE_IN_TABLE,
      label: getQuestionFeatureDisplayName( FbeQuestionFeature.MANIPULATE_IN_TABLE ),
      disabled: false,
      key: 'questionFeature',
  },
  {
    value: FbeQuestionFeature.MUST_ANSWER,
    label: getQuestionFeatureDisplayName( FbeQuestionFeature.MUST_ANSWER ),
    disabled: false,
    key: 'questionFeature',
  },
  {
    value: FbeQuestionFeature.UNIQUE,
    label: getQuestionFeatureDisplayName( FbeQuestionFeature.UNIQUE ),
    disabled: false,
    key: 'questionFeature',
},
]

export const questionTypeOptions = [

  {
    value: 'info1',
    label: '======== Regular ==========',
    disabled: true,
    key: 'questionType',
  },
  {
    value: FbeQuestionType.INFO,
    label: getQuestionTypeDisplayName( FbeQuestionType.INFO ),
    disabled: false,
    key: 'questionType',
  },
  {
    value: FbeQuestionType.TEXT,
    label: getQuestionTypeDisplayName( FbeQuestionType.TEXT ),
    disabled: false,
    key: 'questionType',
  },
  {
    value: FbeQuestionType.DATE,
    label: getQuestionTypeDisplayName( FbeQuestionType.DATE ),
    disabled: false,
    key: 'questionType',
  },

  {
    value: 'info2',
    label: '======== Dynamic choices ==========',
    disabled: true,
    key: 'questionType',
  },
  {
    value: FbeQuestionType.CHOICE,
    label: getQuestionTypeDisplayName( FbeQuestionType.CHOICE ),
    disabled: false,
    key: 'questionType',
  },
  {
    value: FbeQuestionType.MULTI_SELECT,
    label: getQuestionTypeDisplayName( FbeQuestionType.MULTI_SELECT ),
    disabled: false,
    key: 'questionType',
  },
  {
    value: FbeQuestionType.SELECT,
    label: getQuestionTypeDisplayName( FbeQuestionType.SELECT ),
    disabled: false,
    key: 'questionType',
  },

  {
    value: 'info3',
    label: '======== Static choices ==========',
    disabled: true,
    key: 'questionType',
  },
  {
    value: FbeQuestionType.SELECT_ONO,
    label: getQuestionTypeDisplayName( FbeQuestionType.SELECT_ONO ),
    disabled: false,
    key: 'questionType',
  },
  {
    value: FbeQuestionType.SELECT_ONONA,
    label: getQuestionTypeDisplayName( FbeQuestionType.SELECT_ONONA ),
    disabled: false,
    key: 'questionType',
  },
  {
    value: FbeQuestionType.SELECT_WARNING_ONONA,
    label: getQuestionTypeDisplayName( FbeQuestionType.SELECT_WARNING_ONONA ),
    disabled: false,
    key: 'questionType',
  },
  {
    value: FbeQuestionType.SELECT_YN,
    label: getQuestionTypeDisplayName( FbeQuestionType.SELECT_YN ),
    disabled: false,
    key: 'questionType',
  },
  {
    value: FbeQuestionType.SELECT_YN_CHOICE,
    label: getQuestionTypeDisplayName( FbeQuestionType.SELECT_YN_CHOICE ),
    disabled: false,
    key: 'questionType',
  },
  {
    value: FbeQuestionType.SELECT_YNNAE,
    label: getQuestionTypeDisplayName( FbeQuestionType.SELECT_YNNAE ),
    disabled: false,
    key: 'questionType',
  },
  {
    value: 'info4',
    label: '======== Number related ==========',
    disabled: true,
    key: 'questionType',
  },
  {
    value: FbeQuestionType.NUMBER,
    label: getQuestionTypeDisplayName( FbeQuestionType.NUMBER ),
    disabled: false,
    key: 'questionType',
  },
  {
    value: FbeQuestionType.NUMBER_CORRECTION,
    label: getQuestionTypeDisplayName( FbeQuestionType.NUMBER_CORRECTION ),
    disabled: false,
    key: 'questionType',
  },
  {
    value: FbeQuestionType.NUMBER_HIDDEN,
    label: getQuestionTypeDisplayName( FbeQuestionType.NUMBER_HIDDEN ),
    disabled: false,
    key: 'questionType',
  },
  {
    value: FbeQuestionType.NUMBER_TABLE,
    label: getQuestionTypeDisplayName( FbeQuestionType.NUMBER_TABLE ),
    disabled: false,
    key: 'questionType',
  },
  {
    value: 'info5',
    label: '======== Special ==========',
    disabled: true,
    key: 'questionType',
  },


  {
    value: FbeQuestionType.PICTURE,
    label: getQuestionTypeDisplayName( FbeQuestionType.PICTURE ),
    disabled: false,
    key: 'questionType',
  },
  {
    value: FbeQuestionType.PICTURE_NA,
    label: getQuestionTypeDisplayName( FbeQuestionType.PICTURE_NA ),
    disabled: false,
    key: 'questionType',
  },

  {
    value: FbeQuestionType.SIGNATURE,
    label: getQuestionTypeDisplayName( FbeQuestionType.SIGNATURE ),
    disabled: false,
    key: 'questionType',
  },
  {
    value: FbeQuestionType.DEADLINE,
    label: getQuestionTypeDisplayName( FbeQuestionType.DEADLINE ),
    disabled: true,
    key: 'questionType',
},
{
  value: FbeQuestionType.FREE,
  label: getQuestionTypeDisplayName( FbeQuestionType.FREE ),
  disabled: true,
  key: 'questionType',
},
{
    value: FbeQuestionType.HEADER,
    label: getQuestionTypeDisplayName( FbeQuestionType.HEADER ),
    disabled: true,
    key: 'questionType',
  },
  {
    value: FbeQuestionType.WARNING,
    label: getQuestionTypeDisplayName( FbeQuestionType.WARNING ),
    disabled: true,
    key: 'questionType',
  },
  {
    value: FbeQuestionType.SAFETY_YES,
    label: getQuestionTypeDisplayName( FbeQuestionType.SAFETY_YES ),
    disabled: true,
    key: 'questionType',
  },
  {
    value: FbeQuestionType.SAFETY_YES_NO,
    label: getQuestionTypeDisplayName( FbeQuestionType.SAFETY_YES_NO ),
    disabled: true,
    key: 'questionType',
  },
]

export const generatInternalVariableToOptions = (
  sections: FbeSection[],
  key: string
): FbeOption[] => {
  if(sections.length === 0) { return [] }

  const optionList: FbeOption[] = [];

  sections.map(section => {
    if(section.questions.length > 0){
      section.questions.map(question => {
        if(question.internalOutputVariable){
          optionList.push({
            value: question.internalOutputVariable,
            label: question.internalOutputVariable,
            key,
            disabled: false
          })
        }
      })

    }
  });

  return optionList;
}

export const generateExternalDataToOptions = (
  externalData: ExternalData[],
  key: string,
): FbeOption[] => {

  if(!externalData || externalData.length === 0){
      return [];
  }

  const unsortedList: FbeOption[] = [];

  externalData.map(externalDataMapping => {
      if(externalDataMapping.mapping.length > 0){
        externalDataMapping.mapping.map( singleMap => {
          unsortedList.push({
            value: singleMap.dest,
            label: singleMap.dest,
            key,
            disabled: false,
          });
        });
      }
  });

  const list = unsortedList.sort( (a,b) => a.key < b.key ? -1 : 1);

  return list;
}

export const dislayTypeOptions = [
  {
    value: FbeSectionDisplayType.LIST,
    label: getSectionDisplayTypeName( FbeSectionDisplayType.LIST),
    disabled: false,
    key: 'dislayType',
  },
  {
    value: FbeSectionDisplayType.SINGLE,
    label: getSectionDisplayTypeName( FbeSectionDisplayType.SINGLE),
    disabled: false,
    key: 'dislayType',
  },
  {
    value: FbeSectionDisplayType.TABLE,
    label: getSectionDisplayTypeName( FbeSectionDisplayType.TABLE),
    disabled: true,
    key: 'dislayType',
  },
   {
    value: FbeSectionDisplayType.SINGLE_LIST,
    label: getSectionDisplayTypeName( FbeSectionDisplayType.SINGLE_LIST),
    disabled: false,
    key: 'dislayType',
  },
]

export const externalTypeOperatorOptions = [
    {
        value: '',
        label: getMappingTypeOperatorDisplayName( ''),
        disabled: false,
      key: 'externalTypeOperator',
    },
    {
        value: MappingOperator.EQUALS,
        label: getMappingTypeOperatorDisplayName( MappingOperator.EQUALS),
        disabled: false,
      key: 'externalTypeOperator',
    },
    {
        value: MappingOperator.INCLUDES,
        label: getMappingTypeOperatorDisplayName( MappingOperator.INCLUDES),
        disabled: false,
      key: 'externalTypeOperator',
    },
    {
        value: MappingOperator.NOT_EQUALS,
        label: getMappingTypeOperatorDisplayName( MappingOperator.NOT_EQUALS),
        disabled: false,
      key: 'externalTypeOperator',
    },
]

export const externalTypeOptions = [
    {
        value: MappingType.BOOLEAN,
        label: getMappingTypeDisplayName( MappingType.BOOLEAN),
        disabled: false,
      key: 'externalType',
    },
    {
        value: MappingType.NUMBER,
        label: getMappingTypeDisplayName( MappingType.NUMBER),
        disabled: false,
      key: 'externalType',
    },
    {
        value: MappingType.STRING,
        label: getMappingTypeDisplayName( MappingType.STRING),
        disabled: false,
      key: 'externalType',
    },
]

export const criteriaChoiceOptions = [
    {
        value: 'Cnone',
        label: 'None',
        disabled: false,
      key: 'criteriaChoice',
    },
    {
        value: 'Cor',
        label: 'One from a list',
        disabled: false,
      key: 'criteriaChoice',
    },
    {
        value: 'Cand',
        label: 'All from a list',
        disabled: false,
      key: 'criteriaChoice',
    },
]

export const criteriaSourceOptions = [
    {
        value: 'Snone',
        label: 'None',
        disabled: false,
      key: 'criteriaSource',
    },
    {
        value: 'Scharacteristics',
        label: 'SAP Characteristics',
        disabled: false,
      key: 'criteriaSource',
    },
    {
        value: 'SnetworkCharacteristics',
        label: 'SAP Network',
        disabled: false,
      key: 'criteriaSource',
    },
]

export const repeatTypeOptions = [
    {
        value: FbeRepeatType.DIRECT,
        label: getRepeatTypeDisplayName(FbeRepeatType.DIRECT),
        disabled: false,
      key: 'repeatType',
      },
      {
        value: FbeRepeatType.DAILY,
        label: getRepeatTypeDisplayName(FbeRepeatType.DAILY),
        disabled: true,
      key: 'repeatType',
      },
      {
        value: FbeRepeatType.WEEKLY,
        label: getRepeatTypeDisplayName(FbeRepeatType.WEEKLY),
        disabled: true,
      key: 'repeatType',
      },
    ]

export const formTypeOptions = [
    {
        value: FbeType.ADD_IF_NOT_EXISTS,
        label: getFormTypeDisplayName(FbeType.ADD_IF_NOT_EXISTS),
        disabled: false,
        key: 'formType',
    },
    {
        value: FbeType.INDEPENDENT,
        label: getFormTypeDisplayName(FbeType.INDEPENDENT),
        disabled: false,
        key: 'formType',
    },
    {
        value: FbeType.FULL_MERGE,
        label: getFormTypeDisplayName(FbeType.FULL_MERGE),
        disabled: true,
        key: 'formType',
    },
    {
        value: FbeType.MERGE,
        label: getFormTypeDisplayName(FbeType.MERGE),
        disabled: false,
        key: 'formType',
    },
    {
        value: FbeType.REPLACE,
        label: getFormTypeDisplayName(FbeType.REPLACE),
        disabled: false,
        key: 'formType',
    },
]

export const generateTriggerOptions = [
  {
    value: FbeWorkflowStates.TO_BE_STARTED,
    label: getWorkflowDisplayName(FbeWorkflowStates.TO_BE_STARTED),
    disabled: false,
    key: 'generateTrigger',
  },
  {
    value: FbeWorkflowStates.FOR_INSTALLER_ACCEPTANCE,
    label: getWorkflowDisplayName(FbeWorkflowStates.FOR_INSTALLER_ACCEPTANCE),
    disabled: false,
    key: 'generateTrigger',
  },
  {
    value: 'none',
    label: 'None',
    disabled: false,
    key: 'generateResultTrigger',
  },

]

export const generateResultTriggerOptions = [
  {
    value: FbeWorkflowStates.FOR_TESTER_ACCEPTANCE,
    label: getWorkflowDisplayName(FbeWorkflowStates.FOR_TESTER_ACCEPTANCE),
    disabled: false,
    key: 'generateResultTrigger',
  },
  {
    value: FbeWorkflowStates.FOR_FINAL_INSPECTION,
    label: getWorkflowDisplayName(FbeWorkflowStates.FOR_FINAL_INSPECTION),
    disabled: false,
    key: 'generateResultTrigger',
  },
  {
    value: FbeWorkflowStates.FOR_SEB_ACCEPTANCE,
    label: getWorkflowDisplayName(FbeWorkflowStates.FOR_SEB_ACCEPTANCE),
    disabled: false,
    key: 'generateResultTrigger',
  },
  {
    value: FbeWorkflowStates.SEB_ACCEPTED,
    label: getWorkflowDisplayName(FbeWorkflowStates.SEB_ACCEPTED),
    disabled: false,
    key: 'generateResultTrigger',
  },
  {
    value: FbeWorkflowStates.SEB_REJECTED,
    label: getWorkflowDisplayName(FbeWorkflowStates.SEB_REJECTED),
    disabled: false,
    key: 'generateResultTrigger',
  },
  {
    value: FbeWorkflowStates.INSTALLATION_COMPLETE,
    label: getWorkflowDisplayName(FbeWorkflowStates.INSTALLATION_COMPLETE),
    disabled: false,
    key: 'generateResultTrigger',
  },
  {
    value: 'none',
    label: 'None',
    disabled: false,
    key: 'generateResultTrigger',
  },
]

export const activeWorkflowStatusOptions = [
  {
    value: FbeWorkflowStates.TO_BE_STARTED,
    label: getWorkflowDisplayName(FbeWorkflowStates.TO_BE_STARTED),
    disabled: false,
    key: 'activeWorkflowStatus',
  },
  {
    value: FbeWorkflowStates.FOR_INSTALLER_ACCEPTANCE,
    label: getWorkflowDisplayName(FbeWorkflowStates.FOR_INSTALLER_ACCEPTANCE),
    disabled: false,
    key: 'activeWorkflowStatus',
  },
  {
    value: FbeWorkflowStates.INSTALLER_ACCEPTED,
    label: getWorkflowDisplayName(FbeWorkflowStates.INSTALLER_ACCEPTED),
    disabled: false,
    key: 'activeWorkflowStatus',
  },
  {
    value: FbeWorkflowStates.FOR_INSTALLATION_INSPECTION,
    label: getWorkflowDisplayName(FbeWorkflowStates.FOR_INSTALLATION_INSPECTION),
    disabled: false,
    key: 'activeWorkflowStatus',
  },
  {
    value: FbeWorkflowStates.FOR_TESTER_ACCEPTANCE,
    label: getWorkflowDisplayName(FbeWorkflowStates.FOR_TESTER_ACCEPTANCE),
    disabled: false,
    key: 'activeWorkflowStatus',
  },
  {
    value: FbeWorkflowStates.TESTER_ACCEPTED,
    label: getWorkflowDisplayName(FbeWorkflowStates.TESTER_ACCEPTED),
    disabled: false,
    key: 'activeWorkflowStatus',
  },
  {
    value: FbeWorkflowStates.FOR_FINAL_INSPECTION,
    label: getWorkflowDisplayName(FbeWorkflowStates.FOR_FINAL_INSPECTION),
    disabled: false,
    key: 'activeWorkflowStatus',
  },
  {
    value: FbeWorkflowStates.FOR_SEB_ACCEPTANCE,
    label: getWorkflowDisplayName(FbeWorkflowStates.FOR_SEB_ACCEPTANCE),
    disabled: false,
    key: 'activeWorkflowStatus',
  },
  {
    value: FbeWorkflowStates.SEB_ACCEPTED,
    label: getWorkflowDisplayName(FbeWorkflowStates.SEB_ACCEPTED),
    disabled: false,
    key: 'activeWorkflowStatus',
  },
  {
    value: FbeWorkflowStates.SEB_REJECTED,
    label: getWorkflowDisplayName(FbeWorkflowStates.SEB_REJECTED),
    disabled: false,
    key: 'activeWorkflowStatus',
  },
  {
    value: FbeWorkflowStates.INSTALLATION_COMPLETE,
    label: getWorkflowDisplayName(FbeWorkflowStates.INSTALLATION_COMPLETE),
    disabled: false,
    key: 'activeWorkflowStatus',
  },
  {
    value: FbeWorkflowStates.INSTALLATION_ARCHIVED,
    label: getWorkflowDisplayName(FbeWorkflowStates.INSTALLATION_ARCHIVED),
    disabled: false,
    key: 'activeWorkflowStatus',
  },
]

export const sectionFeatureOptions = [
  {
    value: FbeSectionFeature.NO_LOCAL_QUESTION,
    label: getSectionFeatureDisplayName(FbeSectionFeature.NO_LOCAL_QUESTION),
    disabled: false,
    key: 'sectionfeature',
  }
]

export const featureOptions = [
  {
    value: FbeFormFeature.ALLOW_CHANGE_ROLE,
    label: getFormFeatureDisplayName(FbeFormFeature.ALLOW_CHANGE_ROLE),
    disabled: false,
    key: 'feature',
  },
  {
    value: FbeFormFeature.ALLOW_ADDITION,
    label: getFormFeatureDisplayName(FbeFormFeature.ALLOW_ADDITION),
    disabled: false,
    key: 'feature',
  },
  {
    value: FbeFormFeature.ALLOW_REMOVAL,
    label: getFormFeatureDisplayName(FbeFormFeature.ALLOW_REMOVAL),
    disabled: false,
    key: 'feature',
  },
  {
    value: FbeFormFeature.NO_LOCAL_SECTIONS,
    label: getFormFeatureDisplayName(FbeFormFeature.NO_LOCAL_SECTIONS),
    disabled: false,
    key: 'feature',
  },
  {
    value: FbeFormFeature.MANDATORY,
    label: getFormFeatureDisplayName(FbeFormFeature.MANDATORY),
    disabled: false,
    key: 'feature',
  },
  {
    value: FbeFormFeature.MUST_ANSWER,
    label: getFormFeatureDisplayName(FbeFormFeature.MUST_ANSWER),
    disabled: false,
    key: 'feature',
  },
  {
    value: FbeFormFeature.NO_OPEN_DEVIATIONS,
    label: getFormFeatureDisplayName(FbeFormFeature.NO_OPEN_DEVIATIONS),
    disabled: false,
    key: 'feature',
  },
  {
    value: FbeFormFeature.SIGNOFF,
    label: getFormFeatureDisplayName(FbeFormFeature.SIGNOFF),
    disabled: false,
    key: 'feature',
  },
  {
    value: FbeFormFeature.SITE_INFORMATION,
    label: getFormFeatureDisplayName(FbeFormFeature.SITE_INFORMATION),
    disabled: false,
    key: 'feature',
  },
  {
    value: FbeFormFeature.SKIP_QUESTIONS,
    label: getFormFeatureDisplayName(FbeFormFeature.SKIP_QUESTIONS),
    disabled: false,
    key: 'feature',
  },
  {
    value: FbeFormFeature.SUMMARY,
    label: getFormFeatureDisplayName(FbeFormFeature.SUMMARY),
    disabled: false,
    key: 'feature',
  }
];

export const roleOptions = [
  {
    value: TacoRole.INSTALLER,
    label: getRoleDisplayName(TacoRole.INSTALLER),
    disabled: false,
    key: 'role',
  },
  {
    value: TacoRole.TESTER,
    label: getRoleDisplayName(TacoRole.TESTER),
    disabled: false,
    key: 'role',
  },
  {
    value: TacoRole.NEB_SUPERVISOR,
    label: getRoleDisplayName(TacoRole.NEB_SUPERVISOR),
    disabled: false,
    key: 'role',
  },
  {
    value: TacoRole.SEB_SUPERVISOR,
    label: getRoleDisplayName(TacoRole.SEB_SUPERVISOR),
    disabled: false,
    key: 'role',
  },
  {
    value: TacoRole.SEB_SERVICE_ENGINEER,
    label: getRoleDisplayName(TacoRole.SEB_SERVICE_ENGINEER),
    disabled: false,
    key: 'role',
  },
  {
    value: TacoRole.SUBCONTRACTOR_COMPANY,
    label: getRoleDisplayName(TacoRole.SUBCONTRACTOR_COMPANY),
    disabled: false,
    key: 'role',
  },
  {
    value: TacoRole.SUBCONTRACTOR_PERSON_IN_CHARGE,
    label: getRoleDisplayName(TacoRole.SUBCONTRACTOR_PERSON_IN_CHARGE),
    disabled: false,
    key: 'role',
  },
  {
    value: TacoRole.SUBCONTRACTOR_INSTALLER,
    label: getRoleDisplayName(TacoRole.SUBCONTRACTOR_INSTALLER),
    disabled: false,
    key: 'role',
  },
  {
    value: TacoRole.SUBCONTRACTOR_TESTER,
    label: getRoleDisplayName(TacoRole.SUBCONTRACTOR_TESTER),
    disabled: false,
    key: 'role',
  },
];